import { axiosClient } from "api/api";

export const authService = {
  // 🔹 Setup MFA
  generateMfaSecret: (email: string) =>
    axiosClient.post("/api/mfa/setup", { email }),

  // 🔹 Verify MFA
  verifyMfa: (data: { email: string; token: string }) =>
    axiosClient.post("/api/mfa/verify", data),

  // 🔹 Login Verify MFA
  loginVerifyMfa: (data: {
    email: string;
    otp?: string;
    backupCode?: string;
  }) =>
    axiosClient.post("/api/mfa/login-verify", data),

  // 🔹 Disable MFA
  disableMfa: (data: { email: string; otp?: string; backupCode?: string }) =>
    axiosClient.post("/api/mfa/disable", data),

  // 🔹 Get MFA Status
  getMfaStatus: (email: string) =>
    axiosClient.get("/api/mfa/status", {
      params: { email },
    }),
  // 🔹 Regenerate Backup Codes
  regenerateBackupCodes: (email: string) =>
    axiosClient.post("/api/mfa/regenerate-backup-codes", { email }),

  // 🔹 Get Backup Codes
  getBackupCodes: (email: string) =>
    axiosClient.get("/api/mfa/get-backup-codes", {
      params: { email },
    }),

  // 🔹 Request Recovery
  requestMfaRecovery: (data: {
    email: string;
    reason: string;
  }) =>
    axiosClient.post("/api/mfa/request-recovery", data),

  // 🔹 Admin Reset MFA
  resetUserMfa: (email: string) =>
    axiosClient.post("/api/mfa/reset-mfa", { email }),
};